export default "__VITE_ASSET__lqT22boP__"